import { render, staticRenderFns } from "./tablePageList.vue?vue&type=template&id=4e133089&scoped=true"
import script from "./tablePageList.vue?vue&type=script&lang=js"
export * from "./tablePageList.vue?vue&type=script&lang=js"
import style0 from "./tablePageList.vue?vue&type=style&index=0&id=4e133089&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e133089",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/jenkins_home/workspace/tax-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4e133089')) {
      api.createRecord('4e133089', component.options)
    } else {
      api.reload('4e133089', component.options)
    }
    module.hot.accept("./tablePageList.vue?vue&type=template&id=4e133089&scoped=true", function () {
      api.rerender('4e133089', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "found/views/kms_new/components/table_page_list/tablePageList.vue"
export default component.exports